import { render } from "./DoctorHiOrder.vue?vue&type=template&id=adc804d2"
import script from "./DoctorHiOrder.vue?vue&type=script&lang=js"
export * from "./DoctorHiOrder.vue?vue&type=script&lang=js"

import "./DoctorHiOrder.vue?vue&type=style&index=0&id=adc804d2&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__